// extracted by mini-css-extract-plugin
export var buttons = "HzdmX";
export var description = "koiqC";
export var fallbackContainer = "qny9N";
export var illustration = "FTbj8";
export var title = "JfCqe";